export const bridge_contract = "0x7100792De85B4F17A14a675bf4ae7e5d0516e6fa";
export const erc20_contract = "0xB7d5BCF1B0C3e77d7cfb27A0bE00B72403FbA8c9";